import CoreApiService from '@/services/Api/CoreApiService';

export default class GamesApiService extends CoreApiService {
  constructor(config: { isCamelCaseResponse?: boolean; shouldSendSnakeCase?: boolean } = {}) {
    const { isCamelCaseResponse = true, shouldSendSnakeCase = true } = config;
    super({ isCamelCaseResponse, shouldSendSnakeCase });
    this.api = `${process.env.BASE_URL}/survey-search`;
  }
}
